// 电子借据
export interface LoanEvidence {
  adress: string; // 地址
  amount: number | string; // 借款金额 前端自填
  bankCardNo: string; // 绑卡卡号
  bankName: string; // 银行卡开户行
  companyEmail: string; // 公司邮箱
  dueDate: number | string; // 还款日
  email: string; // 个人邮箱
  firstDueDate: string; // 首次还款日
  idCard: string; // 身份证Id
  lentTime: string; // 放款日期 前端自填
  loanUsage: string; // 借款用途 前端自填
  monthRate: string; // 月利率
  period: number | string; // 还款周期 前端自填
  phone: string; // 手机号码
  userName: string; // 名字
  repaymentModel: string // 还款方式
}

// 三方协议
export interface ContractData {
  name: string; // 合同名称
  url: string; // 合同链接
  isThirdUrl: boolean; // 是否三方协议链接
  token?: string; // 马上token
  forceRead?: string; // 是否强制阅读
  clazz?: null
}

// 新银河协议
export interface ConstractPreApply {
  contractNo: string; // 合同编号
  effectiveDate: string; // 协议生效日期
  funderName: string; // 资方名称
  idCard: string; // 身份证ID
  productName: string; // 产品名称
  userName: string; // 用户姓名
  funderCode: string // 资方code
}

// 新银河借款协议
export interface LoanContract {
  commodityId: number;
  applyAmount: string | number; // 申请金额
  applyPeriod: string | number; // 申请期限
  repaymentModel: string; // EPAI(等额本息),EP(等额本金),EPAEI(等本等费),EFIRST(先息后本),EPAEI_2(等本等息)")
  creditApplyId: string | undefined; // 授信流水号ID
}
// 新银河借款合同数据
export interface LoanAgreementPO {
  applyAmount: number; // 借款金额
  applyAmountChinese: string; // 借款金额(汉字大写)
  applyPeriod: number; // 贷款期限
  contractNo: string; // 合同编号
  dailyInterestRate: string; // 日利率 带百分号
  deadLine: string; // 合同截止日期
  effectiveDate: string; // 协议生效日期
  funderName: string; // 资方名称
  idCard: string; // 身份证Id
  lprFloat: string; // lpr浮动基点
  productName: string; // 产品名称
  repayDate: string; // 还款日
  userAccount: string; // 用户账号 支付宝/银行
  userName: string; // 用户姓名
  yearInterestRate: string; // 年利率 带百分号
  repaymentModelStr: string; // 还款方式
  liveAddress: string; // 居住地
  funderCode: string; // 资方code
  mobile: string; // 客户电话
  remarkType: string;
  /** 银行开户行名 */
  bankName: string;
}

// 渠道合同列表
export interface Commodity {
  productId: string; // 授信产品Id
  productName: string; // 产品名称
  productIcon: string;
  contractActive?: number;
  isExpand?: boolean;
  // 路由渠道征信，后端在查询到征信协议时获取到并插入到征信协议信息中
  creditRouteChannel?: string,
  /**
   * 合同类型
   * 返回值为creditInvestigationContract（征信合同）时，不会返回productId、productName、productIcon
   * 且Contract只有一个合同
   *  */
  contractType?: ContractTypeEnum;
  contractList: Contract[];
}
export interface Contract {
  name: string, // 合同名称
  url: string, // 合同地址
  creditRouteChannel?: string, // 路由渠道
}

/** 协议查询入参 */
export interface ContractParamType {
  amount?: number; // 借款金额单位:分，如果是获取借款合同 时，必须传
  capitalCode?: string; // 资方code
  bankCardId?: string; // 银行卡号Id
  bankName?: string; // 银行名称
  cardNo?: string; // 银行卡号
  commodityId?: number; // 商品ID
  loanUsage?: string; // 借款用途
  orderId?: string; // 业务订单ID
  period?: number; // 期数，如果是获取借款合同时，必须传
  type?: string; // 合同类型
  userId?: number; // 金融用户请求由网关自动注入
  sourcePage?: string; // 页面来源:myPage我的页
  fundRouteResponseId?: string; // 资金路由ID
  extendObj?: Record<string, unknown>; // 扩展字段，透传给后端
}

export interface AbTestContractResult {
  /** 强制阅读5s，true:强制；false:不强制 */
  forceRead?: boolean,
  /** 拖到底阅读完，true:强制；false:不强制 */
  completeRead?: boolean,
}

export enum ContractTypeEnum {
  /** 征信合同 */
  creditInvestigationContract = 'creditInvestigationContract',
}

export enum ContractSceneTypeEnum {
  /** 授信 */
  credit = '1',
  /** 提现场景 */
  apply = '2'
}
